import { Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useAtom } from 'jotai'

import { isDrawerOpen as isDrawerOpenAtom } from "atoms/drawer";
import logo from "assets/logo-full.svg";
import { drawerWidth } from 'utils/constants'

const Logo = () => {
  const [isDrawerOpen, setDrawerOpen] = useAtom(isDrawerOpenAtom)

  const handleDrawerToggle = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
  <Box
    width={drawerWidth}
    display={'flex'}
    alignItems={'center'}
    alignContent={'center'}
    flexDirection={'row'}
    px={'22px'}
  >
    <IconButton
      color="inherit"
      aria-label="open drawer"
      onClick={handleDrawerToggle}
      edge="start"
    >
      <MenuIcon />
    </IconButton>
    <Box
      component="img"
      sx={{
        height: 25,
      }}
      alt="Booking Plus"
      src={logo}
    />
  </Box>
)}

export default Logo
